export default __webpack_public_path__ + "static/media/projects.780816b6.jpg";